import { LegalPage, LegalSection } from "./LegalPage";

const CATEGORIES = ["Inappropriate content", "Fake profile", "Harassment", "Underage user", "Spam", "Other"];

const ReportsAndAppealsPage = () => (
  <LegalPage
    title="Reports and Appeals"
    updated="Last updated September 2026"
    testId="reports-appeals-page"
    lede="A concern, received in private. Reviewed by a person."
  >
    <LegalSection title="How to Report a Profile or Content">
      <p>
        You can report any profile or piece of content directly in the app. Tap the three-dot menu
        on a profile or message and select <span className="font-semibold text-ink/90">"Report"</span>. Choose the category that
        best fits, then add a short free-text description so our team understands what happened.
      </p>
      <ul className="mt-4 flex flex-wrap gap-2" data-testid="report-categories">
        {CATEGORIES.map((c) => (
          <li
            key={c}
            className="rounded-full border border-gold/30 bg-gold/5 px-4 py-1.5 text-sm font-semibold text-gold"
            data-testid={`report-category-${c.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {c}
          </li>
        ))}
      </ul>
      <p className="mt-4">All reports are reviewed by the Community Hearts moderation team within 24 hours.</p>
    </LegalSection>

    <LegalSection title="Takedown Notices">
      <p>
        Community Hearts respects intellectual property rights. To submit a DMCA takedown notice, or to
        report non-consensually shared intimate images, email{" "}
        <a href="mailto:legal@communityhearts.app" className="font-semibold text-gold underline underline-offset-4 transition-colors hover:text-gold-deep" data-testid="takedown-email-link">
          legal@communityhearts.app
        </a>{" "}
        with the subject line <span className="font-semibold text-ink/90">"Takedown Request"</span>. Please include:
      </p>
      <ul className="mt-4 list-disc space-y-2 pl-5">
        <li>A description of the content in question</li>
        <li>The profile URL or username where it appears</li>
        <li>Your contact information</li>
      </ul>
      <p className="mt-4">Community Hearts will respond within 72 hours.</p>
    </LegalSection>

    <LegalSection title="How We Review Reports">
      <p>Every report follows the same clear process:</p>
      <ol className="mt-4 list-decimal space-y-2 pl-5">
        <li>The report is received by our moderation team.</li>
        <li>The reported content and account are reviewed against the Community Hearts Community Guidelines.</li>
        <li>Action is taken within 24 hours — ranging from a warning to a permanent ban, based on severity.</li>
        <li>The reporting user is notified of the outcome.</li>
      </ol>
    </LegalSection>

    <LegalSection title="Appeals">
      <p>
        If you believe your account was suspended or removed in error, you may submit an appeal. Email{" "}
        <a href="mailto:appeals@communityhearts.app" className="font-semibold text-gold underline underline-offset-4 transition-colors hover:text-gold-deep" data-testid="appeals-email-link">
          appeals@communityhearts.app
        </a>{" "}
        with the subject line <span className="font-semibold text-ink/90">"Account Appeal"</span>, and include:
      </p>
      <ul className="mt-4 list-disc space-y-2 pl-5">
        <li>Your registered email address</li>
        <li>A brief explanation of why you believe the decision was a mistake</li>
      </ul>
      <p className="mt-4">
        Appeals are reviewed within 5 business days. Community Hearts decisions are final after appeal review.
      </p>
    </LegalSection>
  </LegalPage>
);

export default ReportsAndAppealsPage;
